import React, { useRef, useEffect } from 'react';
import { motion, useInView, useAnimation } from 'framer-motion';
import './About.css';

const About = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: false, margin: '-20% 0px' });
  const controls = useAnimation();

  useEffect(() => {
    if (isInView) {
      controls.start('visible');
    } else {
      controls.start('hidden');
    }
  }, [isInView, controls]);

  const words = `I’m Jackie, a software engineer at Amazon. After earning an MPA from NYU and working at the United Nations, I transitioned into software engineering and completed a Master’s in Information Systems at the University of Toronto. My work is design-driven, intentional, and built to move people as much as machines.`.split(' ');

  const wordVariants = {
    hidden: { opacity: 0, y: 10, filter: 'blur(4px)' },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      filter: 'blur(0px)',
      transition: {
        delay: 0.5 + i * 0.06,
        duration: 0.3,
        ease: 'easeOut',
      },
    }),
  };

  return (
    <motion.section
      ref={ref}
      className="about-container"
      id="about"
      initial="hidden"
      animate={controls}
      variants={{
        hidden: { opacity: 0, y: 50 },
        visible: { opacity: 1, y: 0 },
      }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
    >
      <div className="about-inner">
        <motion.h2
          className="about-heading"
          initial={{ opacity: 0, y: -30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          about me.
        </motion.h2>

        <div className="about-text">
          {words.map((word, i) => (
            <motion.span
              key={i}
              className="about-word"
              custom={i}
              variants={wordVariants}
              initial="hidden"
              animate={controls}
            >
              {word}&nbsp;
            </motion.span>
          ))}
        </div>
      </div>
    </motion.section>
  );
};

export default About;
